import React from "react";
import { Skeleton } from "antd";
import "./StatBox.css";

function StatBox({ icon, title, value, loading }) {
  return (
    <div className="statbox-box">
      {loading ? (
        <Skeleton active avatar paragraph={false} title={{ width: 70 }} />
      ) : (
        <>
          {icon}
          <div className="statbox-text">
            <div className="statbox-title">{title}</div>
            <div className="statbox-value">{value}</div>
          </div>
        </>
      )}
    </div>
  );
}

export default StatBox;
